$borderRadius: 4px;

:host {
  display: block;
  max-width: 100%;
  width: 460px;
  position: relative;
}

.container {
  padding: 16px 48px 20px 48px;
  margin: 0 calc(var(--spacer) * 3);
  border: 1px solid var(--chart-101-pressed-dividers);
  border-radius: $borderRadius;
}

gz-input-number {
  --floating-label-transition: none;
}

.saving-text {
  background-color: var(--grey-layout-200-disabled);
  border-radius: $borderRadius;
  align-self: center;
  padding: calc(var(--spacer) - 4px) var(--spacer);
}

.price {
  flex: 0.5;
}

gz-button::part(button) {
  width: 100%;
}

gz-price-discount {
  position: absolute;
  top: -12px;
  left: -16px;
}

gz-input[class*='color-red'] {
  --input-field-color: var(--red-layout-300-primary);
}

.content {
  width: 161px;

  &.full-width {
    width: 242px;
  }
}

.auto-renewal {
  gz-labeled-content {
    --label-width-percentage: 30%;
    --value-width-percentage: 70%;
  }

  ::part(label) {
    color: var(--chart-300-icon-buttons);
  }

  ::part(content) {
    color: var(--black-layout-700-primary);
    margin-top: -1px;
  }
}
